import { times } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { CardWithTitle } from '@hivebrite/design-system/Card';
import { Link } from '@hivebrite/design-system/Link';

import UserPresentation from 'hb-react/shared/components/DesignSystem/UserPresentation';
import { completeName } from 'helpers/name';

import { UserPresentationLoader } from './UserPresentationLoader';

const UsersList = ({
  isFullWidth = false,
  isLoading = false,
  numberOfUsersDisplayed,
  title,
  titleAs,
  users = [],
  ...props
}) => {
  const contentWidth = isFullWidth ? '100%' : { xl: '50%' };

  const customMarginBottom = (index, totalItems) => {
    const isLastIndex = index === totalItems - 1;
    const isJustBeforeLastIndex = index === totalItems - 2;

    const isTotalOddNumber = totalItems % 2 !== 0;

    const bottomIndex = isTotalOddNumber
      ? isLastIndex
      : isLastIndex || isJustBeforeLastIndex;

    return { l: bottomIndex ? 0 : 6, xl: bottomIndex ? 0 : 8 };
  };

  return (
    <CardWithTitle
      {...props}
      data-testid="recently-active-members"
      title={title}
      titleAs={titleAs}
    >
      {isLoading ? (
        <Grid>
          {times(numberOfUsersDisplayed, (index) => (
            <UserPresentationLoader
              key={index}
              isLastUser={index === numberOfUsersDisplayed - 1}
            />
          ))}
        </Grid>
      ) : (
        <Grid>
          {users.map((user, index) => (
            <Box
              data-testid="group-live-feed-users-list"
              width={contentWidth}
              mb={customMarginBottom(index, users.length)}
              pr={index % 2 ? 0 : { xl: 6 }}
              key={user.id}
            >
              <UserPresentation
                imageUrl={user.photo_thumb_url || user.photo_medium_url}
                subHeader={user.description}
                header={
                  <Link
                    styledOnlyOnHover
                    to={Routes.user_path(user.id)}
                    font="body-semibold-asphalt"
                  >
                    {completeName(user)}
                  </Link>
                }
                imageLink={Routes.user_path(user.id)}
              />
            </Box>
          ))}
        </Grid>
      )}
    </CardWithTitle>
  );
};

UsersList.propTypes = {
  isFullWidth: PropTypes.bool,
  isLoading: PropTypes.bool,
  numberOfUsersDisplayed: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  users: PropTypes.array.isRequired,
  titleAs: PropTypes.string,
};

export default UsersList;

const Grid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
